import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DestinationCarousel from '../components/DestinationCarousel';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PracticalAdvice = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [trips, setTrips] = useState([]);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/trips`)
      .then(res => setTrips(res.data))
      .catch(() => {});
  }, []);

  return (
    <div className="practical-advice-page">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#79c9ea] to-[#5ba8c8] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 uppercase tracking-wide">CONSEILS PRATIQUES</h1>
          <p className="text-lg sm:text-xl opacity-90">Tout ce qu'il faut savoir pour voyager sereinement avec nous</p>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white shadow-md sticky top-0 z-10">
        <div className="container-custom">
          <div className="flex flex-wrap gap-2 py-4 overflow-x-auto">
            <button
              onClick={() => setActiveTab('general')}
              className={`px-4 py-2 rounded-lg font-semibold transition whitespace-nowrap ${
                activeTab === 'general'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              🏠 Le Club
            </button>
            <button
              onClick={() => setActiveTab('formalites')}
              className={`px-4 py-2 rounded-lg font-semibold transition whitespace-nowrap ${
                activeTab === 'formalites'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              📋 Formalités
            </button>
            <button
              onClick={() => setActiveTab('bagages')}
              className={`px-4 py-2 rounded-lg font-semibold transition whitespace-nowrap ${
                activeTab === 'bagages'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              🎒 Bagages
            </button>
            <button
              onClick={() => setActiveTab('communication')}
              className={`px-4 py-2 rounded-lg font-semibold transition whitespace-nowrap ${
                activeTab === 'communication'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              📱 Communication
            </button>
            <button
              onClick={() => setActiveTab('securite')}
              className={`px-4 py-2 rounded-lg font-semibold transition whitespace-nowrap ${
                activeTab === 'securite'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              🔒 Sécurité
            </button>
            <button
              onClick={() => setActiveTab('destinations')}
              className={`px-4 py-2 rounded-lg font-semibold transition whitespace-nowrap ${
                activeTab === 'destinations'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              🌍 Par Destination
            </button>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container-custom max-w-4xl">
          
          {/* Le Club */}
          {activeTab === 'general' && (
            <div className="space-y-6 fade-in">
              <div className="card">
                <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4">Présentation du Club Rhône-Alpes Amitié</h2>
                <div className="prose max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Créé en 1997, <strong>Rhône Amitié</strong> a pour objectif de favoriser la rencontre et l'échange 
                    entre les habitants de notre région. Notre club de voyage propose aujourd'hui <strong>17 voyages de groupe par an</strong>, 
                    en France et à travers le monde, de 1 à 14 jours, pour permettre à chacun de découvrir de nouveaux horizons 
                    dans un esprit de convivialité, de respect et de partage.
                  </p>
                </div>
              </div>

              <div className="card bg-[#5BC5D4] bg-opacity-10">
                <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">👥 Les Accompagnateurs</h3>
                <div className="prose max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Des accompagnateurs bénévoles expérimentés seront présents pendant tout le séjour. 
                    Ils vous rejoindront à la salle d'embarquement et auront pour rôle de :
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4">
                    <li>Faciliter votre arrivée à l'hôtel depuis l'aéroport et votre retour en France</li>
                    <li>Assurer le relais entre les prestataires (hôtel, transport, excursions) et les voyageurs</li>
                    <li>Proposer un programme d'excursions adapté au groupe</li>
                  </ul>
                  <p className="text-gray-700 leading-relaxed">
                    <strong>Important :</strong> Nous ne sommes pas des guides professionnels. Nous assurons des accompagnements 
                    sous forme de promenades, avec différents arrêts, des conseils, des bons plans et des explications selon 
                    nos connaissances et notre expérience de plus de 25 ans. L'esprit est celui de la balade conviviale, 
                    de la découverte, de l'entraide et du partage.
                  </p>
                </div>
              </div>

              <div className="card">
                <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">🤝 Vie de Groupe</h3>
                <div className="prose max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Vous avez fait le choix d'un voyage de groupe avec notre club et nous vous remercions de votre confiance.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Ce séjour est l'occasion de vivre une expérience de rencontre et de partage : chacun est libre de ses 
                    opinions et de ses choix, doit pouvoir vivre son séjour à son rythme. Nous attendons de chacun du 
                    savoir-vivre, de la discrétion, du respect et un langage correct.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Les accompagnateurs s'efforcent de construire un séjour qui convienne à tous, mais doivent penser à 
                    l'intérêt du groupe, riche de ses différences d'âge, de culture et d'envie.
                  </p>
                  <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                    <p className="text-yellow-800 font-semibold">
                      ⚠️ Le non-respect de ces règles de vie pourra entraîner la perte de la qualité de membre du club.
                    </p>
                  </div>
                </div>
              </div>

              <div className="card bg-sky-50" data-testid="advice-placement-bus">
                <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">🚌 Placement dans l'autocar : c'est vous qui choisissez !</h3>
                <div className="prose max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-3">
                    <strong>Nouvelle organisation :</strong> le placement n'est plus effectué par les organisateurs.
                    Après votre inscription, vous recevez un <strong>lien personnel « Mon Bus »</strong> pour choisir
                    vous-même vos places sur le plan du car, <strong>parmi les places disponibles au moment de votre choix</strong> —
                    premiers arrivés, premiers servis.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-3">
                    Le choix des places est <strong>sous votre responsabilité</strong> : pour être assis avec vos amis ou votre famille,
                    coordonnez-vous et choisissez vos places dès réception du lien. Elles restent modifiables jusqu'au départ, selon les disponibilités.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-3">
                    <strong>Pas de choix avant le départ ?</strong> Une place vous sera attribuée automatiquement par les organisateurs,
                    parmi les places restantes — attribution <strong>définitive et non négociable</strong>.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Tous les détails dans la <a href="/charte-placement-bus" className="text-[#5BC5D4] font-semibold underline">charte de placement autocar</a>.
                  </p>
                </div>
              </div>

              <div className="card bg-green-50">
                <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">📅 Règles pour les Départs en Groupe</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <span className="text-[#5BC5D4] font-bold">•</span>
                    <span>Les départs en groupe ne sont pas obligatoires</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-[#5BC5D4] font-bold">•</span>
                    <span>Rendez-vous <strong>15 minutes avant</strong> chaque départ à la réception de l'hôtel</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-[#5BC5D4] font-bold">•</span>
                    <span>Respectez les temps de déplacement en groupe, pas d'arrêt individuel pendant les trajets</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-[#5BC5D4] font-bold">•</span>
                    <span>Si vous n'êtes pas à l'heure à un rendez-vous, le groupe ne pourra pas vous attendre</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-[#5BC5D4] font-bold">•</span>
                    <span>Consultez le groupe WhatsApp chaque jour (modifications possibles)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-[#5BC5D4] font-bold">•</span>
                    <span>Pendant les temps libres : soyez autonomes, ne restez pas seuls, les accompagnateurs restent joignables</span>
                  </li>
                </ul>
              </div>
            </div>
          )}

          {/* Formalités */}
          {activeTab === 'formalites' && (
            <div className="space-y-6 fade-in">
              <div className="card">
                <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4">📋 Formalités Administratives</h2>
                
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Documents Obligatoires</h3>
                  <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
                    <p className="text-blue-800 font-semibold mb-2">Pour les voyages en Europe (Istanbul, Espagne, Italie) :</p>
                    <ul className="list-disc list-inside space-y-2 text-blue-800">
                      <li>Passeport français (valide au moins 6 mois après le retour) OU</li>
                      <li>Carte d'identité française (même périmée de moins de 5 ans) OU</li>
                      <li>Passeport étranger + carte de séjour + visa (selon nationalité)</li>
                    </ul>
                  </div>
                  <div className="bg-red-50 border-l-4 border-red-400 p-4">
                    <p className="text-red-800 font-semibold mb-2">Pour les voyages hors Europe (New York, Thaïlande) :</p>
                    <ul className="list-disc list-inside space-y-2 text-red-800">
                      <li><strong>Passeport biométrique obligatoire</strong> (valide au moins 6 mois après la date de retour)</li>
                      <li><strong>ESTA obligatoire pour les USA</strong> (à faire sur esta.cbp.dhs.gov)</li>
                    </ul>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Voyage avec Mineur</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Livret de famille si nom différent des parents</li>
                    <li><strong>Autorisation de sortie du territoire obligatoire</strong> si le mineur ne voyage pas avec ses parents (formulaire officiel)</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Photocopies et Sécurité</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Faites des photocopies de vos papiers : une à garder sur vous, une à laisser à un proche</li>
                    <li>Gardez une copie numérique sur votre téléphone</li>
                    <li>Rangez vos papiers d'identité dans vos bagages à l'hôtel (ou dans le coffre-fort si disponible)</li>
                  </ul>
                </div>
              </div>

              <div className="card bg-sky-50">
                <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">🏥 Assurance Voyage</h3>
                <div className="prose max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <strong>Assurance voyage santé/rapatriement indispensable :</strong> Si vous n'avez pas souscrit la nôtre, 
                    il faut en prendre une de votre côté.
                  </p>
                  <div className="bg-red-50 border-l-4 border-red-400 p-4">
                    <p className="text-red-800">
                      À défaut, vous partez à vos risques et périls. Les frais médicaux peuvent être très élevés à l'étranger 
                      (notamment aux USA) et les frais d'annulation avant départ ne seront pas remboursés.
                    </p>
                  </div>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    En cas de problème de santé ou d'accident, prévenez <strong>immédiatement</strong> un accompagnateur 
                    qui vous indiquera la marche à suivre selon votre assurance.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Bagages */}
          {activeTab === 'bagages' && (
            <div className="space-y-6 fade-in">
              <div className="card">
                <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4">🎒 Bagages et Équipement</h2>
                
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Bagage en Soute</h3>
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <p className="text-blue-800 font-semibold">✈️ <strong>23 kg par personne</strong> (pour l'aller ET le retour)</p>
                    <p className="text-blue-700 mt-2">⚠️ Attention au poids au retour ! Ne surchargez pas à l'aller.</p>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Bagage à Main</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li><strong>1 pièce</strong> de 55x35x23 cm (8 à 12 kg max selon compagnie)</li>
                    <li>Plus un sac à main ou ordinateur portable</li>
                    <li>Respectez bien ces dimensions, sinon le bagage pourrait finir en soute contre paiement</li>
                    <li>Bagage à roulettes conseillé pour plus de confort</li>
                  </ul>
                  <div className="bg-red-50 border-l-4 border-red-400 p-4 mt-4">
                    <p className="text-red-800 font-semibold">🚫 Liquides interdits en cabine</p>
                    <p className="text-red-700">Au-delà de 100 ml par contenant (eau, gel douche, parfum, dentifrice...)</p>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Étiquetage</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Nom + prénom + adresse de l'hôtel sur chaque bagage</li>
                    <li>Ajoutez un signe distinctif (foulard, ruban coloré...)</li>
                    <li>Prenez une photo de vos bagages avant le départ</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Vêtements et Chaussures</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li><strong>Chaussures adaptées à la marche</strong> (nos destinations se visitent beaucoup à pied)</li>
                    <li>Tenues décontractées, légères et confortables</li>
                    <li>Prévoyez une veste pour le soir et en cas de pluie</li>
                    <li>Parapluie compact</li>
                    <li>Lunettes de soleil et crème solaire</li>
                  </ul>
                  <div className="bg-purple-50 p-4 rounded-lg mt-4">
                    <p className="text-purple-800 font-semibold">🕌 Pour les visites de mosquées :</p>
                    <ul className="list-disc list-inside text-purple-700 mt-2 space-y-1">
                      <li><strong>Hommes :</strong> Pas de short ni débardeur</li>
                      <li><strong>Femmes :</strong> Pantalon long ou jupe longue, manches longues, tête couverte d'un foulard</li>
                    </ul>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Médicaments</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Amenez l'ordonnance pour vos médicaments importants</li>
                    <li>Gardez vos médicaments dans le bagage à main</li>
                    <li>Préparez une petite trousse pharmacie (pansements, désinfectant, médicaments courants)</li>
                  </ul>
                </div>

                <div className="card bg-yellow-50">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">🔌 Adaptateur Électrique</h3>
                  <div className="prose max-w-none">
                    <p className="text-gray-700 leading-relaxed mb-2">
                      <strong>USA :</strong> Adaptateur INDISPENSABLE (prises américaines type A/B, 110V)
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-2">
                      <strong>Europe (Turquie, Espagne) :</strong> Pas besoin d'adaptateur (prises européennes)
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                      💡 Prévoyez une multiprise si vous partagez la chambre + batterie rechargeable portable
                    </p>
                  </div>
                </div>

                <div className="bg-green-50 p-4 rounded-lg">
                  <p className="text-green-800">
                    <strong>✅ Autorisé :</strong> Vous pouvez emporter de la nourriture (sandwiches, confiseries) pour le vol
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Communication */}
          {activeTab === 'communication' && (
            <div className="space-y-6 fade-in">
              <div className="card">
                <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4">📱 Communication & Argent</h2>
                
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Internet et Téléphone</h3>
                  <div className="space-y-4">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <p className="text-blue-800 font-semibold mb-2">📶 Free 5G (19,99€)</p>
                      <p className="text-blue-700">Internet en 4G utilisable à l'étranger, appels/SMS/MMS illimités vers la France et sur place</p>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-lg">
                      <p className="text-purple-800 font-semibold mb-2">🌍 Airalo (eSIM)</p>
                      <p className="text-purple-700">Plateforme d'eSIM internationale. Achetez une eSIM avant le départ, installez-la sur votre smartphone compatible. Nous contacter pour plus d'infos.</p>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg">
                      <p className="text-green-800 font-semibold mb-2">📡 Wifi gratuit</p>
                      <p className="text-green-700">Disponible dans la plupart des hôtels, restaurants, musées et lieux publics</p>
                    </div>
                  </div>
                  <div className="mt-4 bg-yellow-50 border-l-4 border-yellow-400 p-4">
                    <p className="text-yellow-800">
                      <strong>Important :</strong> Désactivez vos données mobiles dans l'avion. Gardez votre téléphone allumé et chargé. 
                      Consultez le groupe WhatsApp chaque jour pour les infos et modifications.
                    </p>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">💰 Argent</h3>
                  <div className="space-y-3">
                    <div className="bg-white p-4 rounded-lg border-2 border-[#5BC5D4]">
                      <p className="text-gray-800 font-semibold mb-2">💳 Carte Bancaire</p>
                      <p className="text-gray-700">Acceptée partout. Attention aux frais bancaires (privilégiez les banques en ligne comme Boursorama ou Revolut)</p>
                    </div>
                    <div className="bg-white p-4 rounded-lg border-2 border-[#5BC5D4]">
                      <p className="text-gray-800 font-semibold mb-2">🏧 Retraits</p>
                      <p className="text-gray-700">Privilégiez les distributeurs dans les banques. Évitez les ATM indépendants (frais élevés). Limitez les petits retraits.</p>
                    </div>
                    <div className="bg-white p-4 rounded-lg border-2 border-[#5BC5D4]">
                      <p className="text-gray-800 font-semibold mb-2">💵 Change</p>
                      <p className="text-gray-700">Possible dans les bureaux de change sur place. Le taux est souvent moins avantageux qu'en France.</p>
                    </div>
                  </div>
                  <div className="mt-4 bg-red-50 border-l-4 border-red-400 p-4">
                    <p className="text-red-800 font-semibold">
                      ⚠️ Chaque voyageur doit avoir ses propres ressources. Les accompagnateurs n'avancent ni ne prêtent d'argent.
                    </p>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">💸 Pourboires</h3>
                  <div className="bg-sky-50 p-4 rounded-lg">
                    <p className="text-sky-800 font-semibold mb-2">USA (obligatoires) :</p>
                    <ul className="list-disc list-inside text-sky-700 space-y-1">
                      <li>15-20% dans les restaurants</li>
                      <li>1-2$ pour bagagistes, taxis</li>
                    </ul>
                    <p className="text-sky-800 font-semibold mt-3 mb-2">Autres destinations :</p>
                    <p className="text-sky-700">Appréciés mais non obligatoires. Gardez toujours des petites coupures sur vous.</p>
                  </div>
                </div>

                <div className="card bg-[#5BC5D4] bg-opacity-10">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">🛍️ Shopping et Souvenirs</h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start gap-3">
                      <span className="text-[#5BC5D4] font-bold">•</span>
                      <span><strong>Bazars et marchés :</strong> Négociez toujours ! Proposez la moitié du prix affiché, payez en monnaie locale</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[#5BC5D4] font-bold">•</span>
                      <span><strong>Centres commerciaux :</strong> Prix fixes (USA, Europe)</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[#5BC5D4] font-bold">•</span>
                      <span><strong>USA :</strong> Les prix affichés sont hors taxes (ajoutez 8-9% au moment de payer)</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[#5BC5D4] font-bold">•</span>
                      <span>Attention aux contrefaçons dans la rue (illégales)</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* Sécurité */}
          {activeTab === 'securite' && (
            <div className="space-y-6 fade-in">
              <div className="card">
                <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4">🔒 Sécurité et Aléas</h2>
                
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Règles de Sécurité</h3>
                  <div className="space-y-3">
                    <div className="bg-green-50 p-4 rounded-lg">
                      <p className="text-green-800 font-semibold mb-2">✅ Nos destinations sont sûres pour les touristes</p>
                      <p className="text-green-700">Forte présence policière dans les quartiers touristiques, mais restez toujours vigilants.</p>
                    </div>
                    <div className="space-y-2 text-gray-700">
                      <p className="font-semibold">Conseils importants :</p>
                      <ul className="list-disc list-inside space-y-2">
                        <li>Gardez vos affaires près de vous dans les lieux très fréquentés</li>
                        <li>Privilégiez un sac à dos antivol, portez-le devant vous dans les foules</li>
                        <li>Fermez bien vos poches</li>
                        <li>Ne laissez rien d'apparent dans votre chambre</li>
                        <li>Évitez de vous promener seul(e) la nuit dans des quartiers non touristiques</li>
                        <li>Privilégiez les sorties en groupe le soir</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="mb-6 bg-red-50 border-l-4 border-red-400 p-4">
                  <h3 className="text-xl font-bold text-red-800 mb-3">⛔ Consignes de Sécurité Strictes</h3>
                  <ul className="space-y-2 text-red-700">
                    <li className="flex items-start gap-2">
                      <span>🚫</span>
                      <span>Ne donnez jamais l'adresse exacte de l'hôtel à des inconnus</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>🚫</span>
                      <span>N'acceptez jamais de boisson ou nourriture d'un inconnu (risque de vol avec sédatif)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>🚫</span>
                      <span>Refusez poliment les sollicitations insistantes (guides improvisés, invitations dans des bars...)</span>
                    </li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">📞 En Cas de Problème</h3>
                  <div className="bg-[#5BC5D4] bg-opacity-10 p-4 rounded-lg">
                    <ul className="space-y-2 text-gray-700">
                      <li>✅ Ayez toujours sur vous la carte de l'hôtel</li>
                      <li>✅ Gardez le numéro d'un accompagnateur dans votre téléphone</li>
                      <li>✅ Les accompagnateurs restent joignables pendant les temps libres</li>
                    </ul>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">Quartiers à Éviter le Soir</h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-sky-50 p-4 rounded-lg">
                      <p className="font-semibold text-sky-800 mb-2">Istanbul :</p>
                      <ul className="list-disc list-inside text-sky-700 text-sm space-y-1">
                        <li>Tarlabaşı</li>
                        <li>Aksaray</li>
                        <li>Laleli</li>
                        <li>Zones peu touristiques de Fatih</li>
                      </ul>
                    </div>
                    <div className="bg-sky-50 p-4 rounded-lg">
                      <p className="font-semibold text-sky-800 mb-2">New York :</p>
                      <ul className="list-disc list-inside text-sky-700 text-sm space-y-1">
                        <li>Certaines parties du Bronx</li>
                        <li>Harlem tard le soir</li>
                        <li>Parties isolées du Queens/Brooklyn</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card bg-blue-50">
                <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">🌪️ Aléas et Imprévus</h3>
                <div className="prose max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Des imprévus peuvent survenir (météo, retard, annulation, grève...). 
                    Merci de faire preuve de patience et de laisser les organisateurs gérer la situation.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    En cas de souci avec une prestation (compagnie aérienne, hôtel...), nous ferons tout pour régler le problème.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Pour un souci dans votre chambre, adressez-vous d'abord à la réception de l'hôtel.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Par Destination */}
          {activeTab === 'destinations' && (
            <div className="space-y-6 fade-in">
              <div className="card">
                <h2 className="text-3xl font-bold text-[#1E3A5F] mb-6">🌍 Conseils par Destination</h2>
                
                {/* Istanbul */}
                <div className="mb-8 pb-8 border-b">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl">🇹🇷</span>
                    <h3 className="text-2xl font-bold text-[#1E3A5F]">Istanbul, Turquie</h3>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <p className="font-semibold text-blue-800 mb-2">🌡️ Météo en juin</p>
                      <p className="text-blue-700">20-28°C, journées longues et ensoleillées</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <p className="font-semibold text-blue-800 mb-2">⏰ Décalage horaire</p>
                      <p className="text-blue-700">+1h par rapport à Lyon</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <p className="font-semibold text-blue-800 mb-2">🔌 Électricité</p>
                      <p className="text-blue-700">Pas besoin d'adaptateur (prises européennes)</p>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <p className="font-semibold text-blue-800 mb-2">🚇 Transport</p>
                      <p className="text-blue-700">Tramway, métro, taxi. Istanbul se visite à pied !</p>
                    </div>
                  </div>

                  <div className="bg-yellow-50 p-4 rounded-lg mb-4">
                    <p className="font-semibold text-yellow-800 mb-2">💡 Bon à savoir</p>
                    <ul className="list-disc list-inside text-yellow-700 space-y-1 text-sm">
                      <li>Négociez toujours dans les bazars (proposez la moitié du prix)</li>
                      <li>Taxis : exigez le compteur, ayez l'adresse en turc</li>
                      <li>Istanbul est une ville de collines, on monte et descend beaucoup</li>
                      <li>Apprenez quelques mots : "Merhaba" (bonjour), "Teşekkür ederim" (merci)</li>
                    </ul>
                  </div>

                  <div className="bg-white p-4 rounded-lg border-2 border-[#5BC5D4]">
                    <p className="font-semibold text-[#1E3A5F] mb-2">🏨 Hôtel Anadolu</p>
                    <p className="text-gray-700 text-sm">
                      Établissement familial dans une maison de 400 ans, situé à Sultanahmet à moins de 10 min à pied 
                      des principaux sites. Ambiance authentique, pas de luxe moderne mais une vraie plongée dans l'Istanbul 
                      d'autrefois. Pas d'ascenseur, salles de bains anciennes, mais situation idéale !
                    </p>
                  </div>
                </div>

                {/* New York */}
                <div className="mb-8 pb-8 border-b">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl">🇺🇸</span>
                    <h3 className="text-2xl font-bold text-[#1E3A5F]">New York, USA</h3>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-red-50 p-4 rounded-lg">
                      <p className="font-semibold text-red-800 mb-2">🌡️ Météo en octobre</p>
                      <p className="text-red-700">15-25°C, météo changeante, averses possibles</p>
                    </div>
                    <div className="bg-red-50 p-4 rounded-lg">
                      <p className="font-semibold text-red-800 mb-2">⏰ Décalage horaire</p>
                      <p className="text-red-700">-6h par rapport à Lyon</p>
                    </div>
                    <div className="bg-red-50 p-4 rounded-lg">
                      <p className="font-semibold text-red-800 mb-2">🔌 Électricité</p>
                      <p className="text-red-700">Adaptateur INDISPENSABLE (type A/B, 110V)</p>
                    </div>
                    <div className="bg-red-50 p-4 rounded-lg">
                      <p className="font-semibold text-red-800 mb-2">🚇 Transport</p>
                      <p className="text-red-700">Métro 24h/24 (MetroCard Unlimited conseillée)</p>
                    </div>
                  </div>

                  <div className="bg-sky-50 p-4 rounded-lg mb-4">
                    <p className="font-semibold text-sky-800 mb-2">💡 À savoir</p>
                    <ul className="list-disc list-inside text-sky-700 space-y-1 text-sm">
                      <li>Les prix affichés sont HORS TAXES (ajoutez 8-9%)</li>
                      <li>Pourboires OBLIGATOIRES : 15-20% restaurants, 1-2$ services</li>
                      <li>L'eau du robinet est potable</li>
                      <li>Les passages piétons ne sont pas toujours prioritaires</li>
                      <li>Métro vieillissant : marches hautes, pas toujours d'ascenseur</li>
                      <li>Applications utiles : MTA, Citymapper</li>
                    </ul>
                  </div>

                  <div className="bg-white p-4 rounded-lg border-2 border-[#5BC5D4]">
                    <p className="font-semibold text-[#1E3A5F] mb-2">🏨 The L Hotel Brooklyn</p>
                    <p className="text-gray-700 text-sm mb-2">
                      135 32nd Street, Brooklyn, NY 11232 | ☎️ +1 718-788-1801
                    </p>
                    <p className="text-gray-700 text-sm">
                      Hôtel moderne à Brooklyn, à 300m de la station 36th Street (lignes D, N, R, W). 
                      Accès direct à Manhattan en 20-35 min. Quartier calme et sûr.
                    </p>
                  </div>
                </div>

                {/* Espagne */}
                <div className="mb-8">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl">🇪🇸</span>
                    <h3 className="text-2xl font-bold text-[#1E3A5F]">Lloret del Mar, Espagne</h3>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <p className="font-semibold text-yellow-800 mb-2">🌡️ Météo été</p>
                      <p className="text-yellow-700">25-30°C, ensoleillé, parfait pour la plage</p>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <p className="font-semibold text-yellow-800 mb-2">⏰ Décalage horaire</p>
                      <p className="text-yellow-700">Même heure qu'en France</p>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <p className="font-semibold text-yellow-800 mb-2">🔌 Électricité</p>
                      <p className="text-yellow-700">Pas besoin d'adaptateur</p>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <p className="font-semibold text-yellow-800 mb-2">🚗 Transport</p>
                      <p className="text-yellow-700">Autocar grand tourisme depuis Lyon</p>
                    </div>
                  </div>

                  <div className="bg-white p-4 rounded-lg border-2 border-[#5BC5D4]">
                    <p className="font-semibold text-[#1E3A5F] mb-2">🏨 Hôtel Oasis Park 4⭐</p>
                    <p className="text-gray-700 text-sm">
                      Hôtel moderne avec spa (jacuzzi, hammam), 3 piscines, salle de sport. 
                      Pension complète (eau et vin inclus). À 5 minutes de la mer. 
                      Animations journée et spectacles le soir.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* Carrousel photos */}
      {trips.length > 0 && (
        <section className="section bg-gray-50" data-testid="carousel-section">
          <div className="container-custom">
            <h2 className="text-2xl sm:text-3xl font-bold text-center mb-3 text-[#1E3A5F]">Nos Destinations en Images</h2>
            <p className="text-center text-gray-600 mb-10 text-base sm:text-lg">Laissez-vous inspirer par nos plus belles photos</p>
            <DestinationCarousel trips={trips} />
          </div>
        </section>
      )}
    </div>
  );
};

export default PracticalAdvice;
